import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Topnav from '../../components/adminNav/Topnav';
import Sidebar from '../../components/sidebar/Sidebar';
import { BASE_URL } from '../../requestMethod';

const User = () => {
    const [users, setUsers] = useState([]);
    const user = useSelector((state) => state.user.currentUser);
    useEffect(() => {
        const getUsers = async () => {
            try {
                const res = await axios.get(`${BASE_URL}Settings/vendorusers?page=0`, {
                    mode: 'no-cors',
                    headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
                })
                // console.log(res.data.returnObj);
                setUsers(res.data.returnObj);
            }
            catch (err) {
                console.log(err)
            }
        }
        getUsers();
    }, []);

    return (
        <div className="container-scroller">
            <Topnav />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> Users </h3>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                {/* <li className="breadcrumb-item"><a href="/createProduct" class="btn btn-gradient-success btn-fw">Add Product</a></li> */}
                            </ol>
                        </nav>
                    </div>

                    <div className="row">
                        <div className="col-12 grid-margin">
                            <div className="card">
                                <div className="card-body">

                                    <h4 className="card-title">All Availible Users</h4>

                                    <div className="table-responsive">
                                        <table className="table mb-5">
                                            <thead>
                                                <tr>
                                                    <th> Name </th>
                                                    <th> Email </th>
                                                    <th> Phone Number </th>
                                                    <th> Action </th>
                                                </tr>
                                            </thead>
                                            {users ? (
                                                <tbody>
                                                    {users.map((item) => (
                                                        <tr key={item.id}>

                                                            <td> {item.customerName} </td>
                                                            <td>
                                                                {item.email}
                                                            </td>
                                                            <td>
                                                                {item.mobilePhone}
                                                            </td>
                                                            <td>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <p>No user Yet!</p>
                                            )}

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default User;
